import { GROUP_TYPE, IUpsellConfigData } from '@app/admin/fleet-card/shared/nudge-upsells/interfaces';

export const BTN_TEXT_KEYS = {
  applyNow: $localize`Apply now`,
  imInterested: $localize`I'm interested`,
  learnMore: $localize`Learn more`,
};

export const PROMO_CONTENT_CONFIG: IUpsellConfigData = {
  [GROUP_TYPE.estimatedSavingsUM30to399]: {
    header: (potentialSavings: string): string => {
      return $localize`Save an estimated ${potentialSavings} annually with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.imInterested,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.estimatedSavingsUM30to399,
  },
  [GROUP_TYPE.estimatedSavings1to9]: {
    header: (potentialSavings: string): string => {
      return $localize`Save an estimated ${potentialSavings} annually with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.applyNow,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.estimatedSavings1to9,
  },
  [GROUP_TYPE.averageSavingsUM10to399]: {
    header: (potentialSavings: string): string => {
      return $localize`Save ${potentialSavings} per year on average with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.imInterested,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.averageSavingsUM10to399,
  },
  [GROUP_TYPE.averageSavings1to9]: {
    header: (potentialSavings: string): string => {
      return $localize`Save ${potentialSavings} per year on average with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.applyNow,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.averageSavings1to9,
  },
  [GROUP_TYPE.estimatedSavingsUM10to29]: {
    header: (potentialSavings: string): string => {
      return $localize`Save an estimated ${potentialSavings} annually with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.applyNow,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.estimatedSavingsUM10to29,
  },
  [GROUP_TYPE.estimatedSavingsUM30to49]: {
    header: (potentialSavings: string): string => {
      return $localize`Save an estimated ${potentialSavings} annually with the Motive Card`;
    },
    body: $localize`Apply before December 31st to lock your savings!`,
    primaryBtnText: BTN_TEXT_KEYS.applyNow,
    secondaryBtnText: BTN_TEXT_KEYS.learnMore,
    upsellId: GROUP_TYPE.estimatedSavingsUM30to49,
  },
};